import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DASHBOARD, LOGIN, SOCIETY_CONTROLLER, SOCIETY_PORTAL, SOCIETY_PORTAL_FORGOT_PASSWORD } from "../../../../Routing/routes";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, Form, Formik } from "formik";
import { loginValidation } from "../../../../validationSchema/SocietyController/authSchema";
import CircularProgress from "@mui/material/CircularProgress";
import { login } from "../../../../redux/actions/AuthActions/LoginAction";
import webTokenStorer from "../../../../utils/webStorer";

const Login = () => {
    const [showPass, setShowPass] = useState(false);
    const navigate = useNavigate();
    const loginDetails = useSelector(state => state.loginReducer);
    const dispatch = useDispatch();

    const handleSaveClick = (values, { resetForm }) => {
        dispatch(login({ ...values, onSuccess: () => { navigate(SOCIETY_PORTAL + DASHBOARD) } }));
    }

    return (
        <>
            {webTokenStorer.getToken() ? <Navigate to={SOCIETY_PORTAL + DASHBOARD} /> :
                <section className='auth bg-base d-flex flex-wrap'>
                    <div className='auth-left d-lg-block d-none'>
                        <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                            <img src="/assets/images/auth/auth-img.png" alt="" />
                        </div>
                    </div>
                    <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                        {loginDetails?.loading ? (
                            <div className="tw-text-center"><CircularProgress /></div>
                        ) : (
                            <div className='max-w-464-px mx-auto w-100'>
                                <div>
                                    <h4 className='mb-12'>Society Login</h4>
                                    <p className='mb-32 text-secondary-light text-lg'>
                                        Welcome back! Please enter your credentials
                                    </p>
                                </div>
                                <Formik
                                    initialValues={{
                                        email: '',
                                        password: '',
                                    }}
                                    enableReinitialize={true}
                                    validationSchema={loginValidation}
                                    onSubmit={handleSaveClick}
                                >
                                    {(formik) => (
                                        <Form>
                                            {loginDetails?.geofenceError && (
                                                <div className="alert alert-warning d-flex align-items-start gap-2 radius-8 mb-16 px-16 py-12" role="alert">
                                                    <Icon icon="mdi:map-marker-alert-outline" className="text-xl flex-shrink-0 mt-1" />
                                                    <div className="flex-grow-1">
                                                        <div className="fw-semibold text-sm mb-1">Outside society premises</div>
                                                        <div className="text-sm mb-8">{loginDetails.geofenceError}</div>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-sm btn-warning text-white radius-8 px-16 py-8 d-inline-flex align-items-center gap-1"
                                                        >
                                                            <Icon icon="mdi:crosshairs-gps" /> Retry with location
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="mb-16">
                                                <div className='icon-field'>
                                                    <span className='icon top-50 translate-middle-y'>
                                                        <Icon icon='mage:email' />
                                                    </span>
                                                    <input
                                                        type='email'
                                                        className='form-control h-56-px bg-neutral-50 radius-12'
                                                        placeholder='Email'
                                                        onChange={(e) => formik.setFieldValue('email', e.target.value)}
                                                        value={formik.values.email}
                                                        required
                                                    />
                                                </div>
                                                <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                    <ErrorMessage name={`email`} />
                                                </div>
                                            </div>
                                            <div className="mb-16">
                                                <div className='icon-field'>
                                                    <span className='icon top-50 translate-middle-y'>
                                                        <Icon icon='f7:lock' />
                                                    </span>
                                                    <input
                                                        type={showPass ? 'text' : 'password'}
                                                        className='form-control h-56-px bg-neutral-50 radius-12'
                                                        placeholder='Password'
                                                        name="password"
                                                        onChange={(e) => formik.setFieldValue('password', e.target.value)}
                                                        value={formik.values.password}
                                                    />
                                                    {showPass ? (
                                                        <span
                                                            onClick={() => setShowPass(!showPass)}
                                                            className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                                        ></span>
                                                    ) : (
                                                        <span
                                                            onClick={() => setShowPass(!showPass)}
                                                            className="toggle-password ri-eye-off-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                                        ></span>
                                                    )}
                                                </div>
                                                <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                    <ErrorMessage name={`password`} />
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className='d-flex justify-content-between gap-2'>
                                                    <Link to={SOCIETY_PORTAL + SOCIETY_PORTAL_FORGOT_PASSWORD} className='text-primary-600 fw-medium'>
                                                        Forgot Password?
                                                    </Link>
                                                </div>
                                            </div>
                                            <button
                                                type='submit'
                                                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                                            >
                                                Sign In
                                            </button>
                                            <Link
                                                to={SOCIETY_CONTROLLER + LOGIN}
                                                className='btn btn-outline-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-16 d-flex align-items-center justify-content-center'
                                            >
                                                Go to Administrator Login
                                            </Link>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        )}
                    </div>
                </section>}
        </>
    );
}

export default Login;
